import { render } from "./TrialEndDialogHOC.vue?vue&type=template&id=eb53e832"
import script from "./TrialEndDialogHOC.vue?vue&type=script&lang=js"
export * from "./TrialEndDialogHOC.vue?vue&type=script&lang=js"
script.render = render

export default script